import { FaArrowRight } from "react-icons/fa6"
import { useSelector } from "react-redux"
import { DecodeHtml } from "../../utils/decodeHtml"
import { useEffect, useState } from "react"
import Accordion from "../campusLife/accordion"


const Mission = () => {
    const state = useSelector(state => state.aboutUnitenContent)



    const aboutUniten = state?.data?.properties

    const title = aboutUniten?.title
    const description = DecodeHtml({ html: aboutUniten?.richTextContent?.markup })
     const [accordion, setAccordion] = useState([])
    
        useEffect(() => {
           
            setAccordion(
                aboutUniten?.accordionContent?.items?.map((content) => {
                    let acc = content?.content?.properties
                    return {
                        question: acc?.label,
                        answer: acc?.buttonDownload && <a href={`${acc?.buttonDownload[0]?.url}`} target="_blank" rel="noreferrer" download={acc?.buttonDownload[0]?.url} >{acc?.buttonDownload[0]?.name}</a>,
                        open: false
                    }
                }
                )
            )
        }, [aboutUniten?.accordionContent])
//     const items = [
//         `Strong fundamental knowledge, scholarly attainment and technical competence in the students’ respective disciplines`,
//         `Advanced knowledge and learning experience amongst the university community through research and innovation that will best serve human society`,
//         `Professionalism, leadership, ethics and continual self-development amongst the university community`,
//         `An appreciation of social, cultural, global and environmental responsibilities of a professional and the application of sustainable development`,
//     ]
//     const orderItems = [
//         `Integrity`,
//         `Collaborative`,
//         `Customer Centricity`,
//         `Professionalism`,
//         `Forward Thinking`,
//         `Mindfulness`,
//         `Tagline
// Creative, Innovative & Energetic.`,
//     ]
//     const logo = "/assets/logo_w-1.png"
    return (
        <div className="flex flex-col gap-5 ">
            <h1 className="w-auto max-w-[30ch] text-3xl font-bold text-slate-900  2xl:text-5xl !leading-tight">{title}</h1>
            
            <p className='w-auto whitespace-pre-line'>{description}</p>

             <div className="my-5">
                            {accordion && <Accordion accordion={accordion} setAccordion={setAccordion} />}
                        </div>
            {/* <p className="w-auto  text-justify text-[#071946B2]  text-base font-normal leading-normal">{`A leading global energy university that shapes a sustainable future. We strive to advance knowledge and learning experience through research and innovation that will best serve human society`}</p> */}

            {/* <div className="flex flex-col gap-4">
                <h2 className="w-auto  text-[#071946B2]  text-2xl underline underline-offset-1 capitalize font-bold leading-normal">{`Educational Goals`}</h2>
                <p className="w-auto  text-justify text-[#071946B2]  text-base font-semibold leading-normal"> To inculcate:</p>
                <ul className="flex flex-col list-disc ml-10  gap-2">
                    {
                        items.map((item, index) => <li key={index} className="text-sky-950  text-opacity-60 text-base font-semibold leading-normal w-auto">{item}</li>)
                    }
                </ul>
            </div>
            <div className="flex flex-col gap-4">
                <h2 className="w-auto  text-[#071946B2]  text-2xl underline underline-offset-1 capitalize font-bold leading-normal">{`6 Core Values (ICCP.FM)`}</h2>
                <ol className="flex flex-col list-decimal ml-5  gap-2">
                    {
                        orderItems.map((item, index) => <li key={index} className="text-sky-950  text-opacity-60 text-base font-semibold leading-normal w-auto">{item}</li>)
                    }
                </ol>
            </div>

            <div className="flex flex-col gap-5 mt-8">
                <img src={logo} className="max-w-[30rem] bg-gray-100 h-auto max-h-[20rem]  object-cover italic" alt="Logo" />
                <div className="flex flex-col border">
                    <div className="border-b place-items-center md:place-items-start grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 p-5 py-8">
                        <h2 className="w-auto  text-3xl font-bold text-slate-900 text-center md:text-start  leading-tight">{`UNITEN Logo`}</h2>
                        <button className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                            <span className="text-white text-base font-bold capitalize flex items-center gap-3">download <FaArrowRight /></span>
                        </button>
                    </div>
                    <div className="border-b place-items-center md:place-items-start grid grid-cols-1 md:grid-cols-[70%_30%] gap-10 p-5 py-8">
                        <h2 className="w-auto  text-3xl font-bold text-slate-900 text-center md:text-start  leading-tight">{`25 Years Logo`}</h2>
                        <button className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                            <span className="text-white text-base font-bold capitalize flex items-center gap-3">download <FaArrowRight /></span>
                        </button>
                    </div>
                    <div className="grid place-items-center md:place-items-start grid-cols-1 md:grid-cols-[70%_30%] gap-10 p-5 py-8">
                        <h2 className="w-auto  text-3xl font-bold text-slate-900 text-center md:text-start  leading-tight">{` BOLD2025 Strategic Plan Booklet - Download`}</h2>
                        <button className="px-8 py-4 w-fit bg-red-800 rounded justify-center items-center gap-4 flex">
                            <span className="text-white text-base font-bold capitalize flex items-center gap-3">download <FaArrowRight /></span>
                        </button>
                    </div>
                </div>

            </div> */}
        </div>
    )
}

export default Mission